import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { ClickableElement } from '@/atoms';
import { book, regular, flexCenter, colors, resetButton } from '@/styles';

/**
 * VideoButtonItem component
 *
 * @param {import('./VideoButtonItem').VideoButtonItemProps} props
 */
export function VideoButtonItem({ className, SvgElement, name, handleClick, text, isRebrand }) {
  return (
    <ClickableElement onClick={handleClick} tagName="button" className={className}>
      <div className="circle">
        <SvgElement className={name} fill={colors.almostBlack} />
      </div>
      <span>{text}</span>
    </ClickableElement>
  );
}

VideoButtonItem.propTypes = {
  className: PropTypes.string.isRequired,
  SvgElement: PropTypes.elementType.isRequired,
  name: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  isRebrand: PropTypes.bool.isRequired,
};

const styledVideoButtonItem = styled(VideoButtonItem)`
  ${({ isRebrand }) => (isRebrand ? regular() : book())}
  ${resetButton()}
  font-size: 0.8rem;
  margin: 2rem;
  color: ${colors.battleship};

  .circle {
    ${flexCenter()}
    border-radius: 50%;
    background-color: ${colors.white};
    width: 4.7rem;
    height: 4.7rem;
    margin-bottom: 0.7em;
  }

  .like {
    margin-bottom: 0.25rem;
  }

  .reply {
    margin-left: 3%;
  }

  .replay {
    margin-bottom: 0.25rem;
  }
`;

export default styledVideoButtonItem;
